import React from "react";
import { useState } from "react";
import { agregarCarrito } from "../../helpers/carrito";
import url from "../config/Config";
import { formatHumansBs } from "../../helpers/formatHuman";
import { getImage } from "../../helpers";

const ProductoItemSlide = ({ item, listaDetalleProducto, setProduct }) => {

    const [agregadoCarrito, setAgregadoCarrito] = useState(false);

    const buttonCarrito = (product) => {
        setAgregadoCarrito(true);
        agregarCarrito(product);
        setTimeout(() => {
            setAgregadoCarrito(false);
        }, 1000);
    };

    return (
        <div className="m-1 bg-white p-3 rounded-xl">
            <div className="relative group px-2 lg:px-6">
                <img
                    src={getImage(item.imagen)}
                    alt="Imagen"
                    className="h-30 w-full object-cover"
                />
            </div>
            <div className="px-2 space-y-2">
                <p className="text-gray-400 text-center uppercase font-semibold">
                    1ERTY6
                </p>
                <div className="flex flex-col">
                    <p
                        onClick={() => {
                            listaDetalleProducto(item.idproducto);
                            setProduct(item);
                        }}
                        className="text-truncate text-start lg:text-center hover:cursor-pointer hover:underline"
                    >
                        {url.capitalizeWords(item.nombre)}
                    </p>
                    <p className="font-bold text-center text-base  lg:text-lg">
                        {formatHumansBs(
                            (
                                item.precio -
                                (item.decuento / 100) * item.precio
                            ).toFixed(2)
                        )}
                    </p>
                    <p className="text-gray-500 font-semibold text-[12px] lg:text-base flex items-center flex-row  justify-between  lg:flex-col">
                        3 cuotas:
                        <span className="font-bold text-gray-600 lg:text-lg">
                            {formatHumansBs(item.precio / 3)}
                        </span>
                    </p>
                </div>
                <button
                    style={{
                        padding: "0",
                        margin: "0",
                        height: "auto",
                    }}
                    className={`rounded-full lg:rounded-lg font-semibold text-white block w-full py-2 px-3 text-center ${
                        agregadoCarrito
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-tertiary-personalize hover:no-underline"
                    }`}
                    onClick={() => buttonCarrito(item)}
                    disabled={agregadoCarrito}
                >
                    Agregar
                </button>
            </div>
        </div>
    );
};

export default ProductoItemSlide;
